var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
export default function SimpleTextAndMedia(props) {
    var fields = props.fields, children = props.children, isFlyoverSite = props.isFlyoverSite;
    var TitleTag = (fields.titleTag || 'h1');
    return (React.createElement("div", __assign({ className: "strip spa-simple-text-and-media "
            + fields.backgroundColor
            + (fields.imagePosition == "right" ? " image-on-right" : " image-on-left")
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-lg-6 col-xl-5 offset-xl-1 mb-5 mb-lg-0 me-lg-auto order-md-1 " + (fields.imageOnTop ? "order-2 mt-5" : "") },
                    React.createElement("div", { className: "h-100 d-flex align-items-center" },
                        React.createElement("div", { className: "content-container" },
                            fields.label &&
                                React.createElement("div", { className: "pre-title" },
                                    " ",
                                    fields.label,
                                    " "),
                            fields.displayTitle &&
                                React.createElement(TitleTag, { className: "title " + fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null,
                            React.createElement("div", { className: "mt-3 abstract", dangerouslySetInnerHTML: { __html: fields.description } }),
                            fields.link && fields.linkLabel &&
                                React.createElement("a", { href: fields.link, title: fields.linkLabel, className: "btn btn-primary mt-4" }, fields.linkLabel)))),
                React.createElement("div", { className: "col-lg-5 col-xl-5 order-md-1 " + (fields.imageOnTop ? "order-1" : "") },
                    React.createElement("div", { className: "image-container" },
                        React.createElement("img", { className: "img-fluid", src: fields.image, alt: fields.image_description, title: fields.image_title })))))));
}
